<template>
  <div
    class="absolute left-[-16px] top-[50%] z-[999] flex translate-x-0 translate-y-[-50%] rotate-0 skew-x-0 skew-y-0 scale-100 transform cursor-pointer items-center overflow-hidden rounded"
  >
    <a
      id="dragHandle"
      data-testid="arrow-drag-handle"
      class="movement-drag-handle grid bg-structure-1 p-0.5 !text-white transition duration-300 hover:bg-structure-2"
      :class="{
        '!bg-content-1 hover:!bg-content-2': block,
      }"
      @mouseover="displayMenu = true"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 10.25C19 10.4609 18.8945 10.707 18.7188 10.8477L15.625 13.6602C15.4492 13.8359 15.2383 13.9062 15.0625 13.9062C14.5703 13.9062 14.2188 13.5547 14.2188 13.0625C14.2188 12.8516 14.2891 12.6055 14.4648 12.4648L15.9414 11.0938H10.8438V16.2266L12.1797 14.75C12.3203 14.5742 12.5664 14.4688 12.7773 14.4688C13.2695 14.4688 13.6562 14.8555 13.6562 15.3125C13.6562 15.5234 13.5508 15.7344 13.4102 15.9102L10.5977 19.0039C10.457 19.1797 10.2109 19.25 10 19.25C9.75391 19.25 9.50781 19.1797 9.36719 19.0039L6.55469 15.9102C6.41406 15.7344 6.34375 15.5234 6.34375 15.3125C6.34375 14.8555 6.69531 14.4688 7.15234 14.4688C7.36328 14.4688 7.60938 14.5742 7.75 14.75L9.15625 16.2266V11.0938H4.02344L5.5 12.4648C5.67578 12.6055 5.78125 12.8516 5.78125 13.0625C5.78125 13.5547 5.39453 13.9062 4.9375 13.9062C4.72656 13.9062 4.51562 13.8359 4.33984 13.6953L1.24609 10.8828C1.07031 10.7422 1 10.4961 1 10.25C1 10.0039 1.07031 9.75781 1.24609 9.61719L4.33984 6.80469C4.51562 6.66406 4.72656 6.59375 4.9375 6.59375C5.39453 6.59375 5.74609 6.98047 5.74609 7.4375C5.74609 7.68359 5.67578 7.89453 5.5 8.07031L4.02344 9.40625H9.15625V4.27344L7.78516 5.75C7.64453 5.96094 7.39844 6.03125 7.15234 6.03125C6.66016 6.03125 6.34375 5.67969 6.34375 5.1875C6.34375 4.97656 6.41406 4.80078 6.55469 4.625L9.36719 1.53125C9.50781 1.35547 9.75391 1.25 10 1.25C10.2109 1.25 10.457 1.35547 10.5977 1.53125L13.4102 4.625C13.5508 4.80078 13.6562 4.97656 13.6562 5.1875C13.6562 5.67969 13.2695 6.03125 12.8125 6.03125C12.5664 6.03125 12.3203 5.96094 12.1797 5.75L10.8438 4.27344V9.40625H15.9414L14.4648 8.07031C14.2891 7.89453 14.1836 7.68359 14.1836 7.4375C14.1836 6.98047 14.5703 6.59375 15.0273 6.59375C15.2383 6.59375 15.4492 6.66406 15.625 6.80469L18.7188 9.65234C18.8945 9.79297 19 10.0391 19 10.25Z"
          fill="currentColor"
        />
      </svg>
    </a>
    <transition
      v-if="!(disableUpMovement && disableDownMovement)"
      name="slide-fade"
    >
      <div v-if="displayMenu" class="flex" @mouseleave="displayMenu = false">
        <a
          v-if="!disableUpMovement"
          data-testid="up-movement"
          class="grid bg-structure-1 p-0.5 !text-white transition duration-300 hover:bg-structure-2"
          :class="{
            '!bg-content-1 hover:!bg-content-2': block,
          }"
          @click.stop="doUpMovement()"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.19141 6.10156C9.61328 5.64453 10.3516 5.64453 10.7734 6.10156L16.3984 11.7266C16.8555 12.1484 16.8555 12.8867 16.3984 13.3086C15.9766 13.7656 15.2383 13.7656 14.8164 13.3086L10 8.49219L5.14844 13.3086C4.72656 13.7656 3.98828 13.7656 3.56641 13.3086C3.10938 12.8867 3.10938 12.1484 3.56641 11.7266L9.19141 6.10156Z"
              fill="currentColor"
            />
          </svg>
        </a>
        <a
          v-if="!disableDownMovement"
          data-testid="down-movement"
          class="grid bg-structure-1 p-0.5 !text-white transition duration-300 hover:bg-structure-2"
          :class="{
            '!bg-content-1 hover:!bg-content-2': block,
          }"
          @click.stop="doDownMovement()"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.19141 14.4336C9.61328 14.8906 10.3516 14.8906 10.7734 14.4336L16.3984 8.80859C16.8555 8.38672 16.8555 7.64844 16.3984 7.22656C15.9766 6.76953 15.2383 6.76953 14.8164 7.22656L10 12.043L5.14844 7.22656C4.72656 6.76953 3.98828 6.76953 3.56641 7.22656C3.10938 7.64844 3.10938 8.38672 3.56641 8.80859L9.19141 14.4336Z"
              fill="currentColor"
            />
          </svg>
        </a>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
  import { ref } from "vue";
  defineProps({
    disableUpMovement: Boolean,
    disableDownMovement: Boolean,
    block: Boolean,

    customLeftPos: {
      type: Number,
      default: 60,
    },
  });

  const displayMenu = ref(false);

  const doUpMovement = () => {
    displayMenu.value = false;
    emits("doUpMovement");
  };

  const doDownMovement = () => {
    displayMenu.value = false;
    emits("doDownMovement");
  };

  const emits = defineEmits(["doUpMovement", "doDownMovement"]);
</script>

<style scoped>
  /* .arrow {
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 999px;
    background-color: #3c4048;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
    color: #fff !important;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
  }

  .arrow:hover {
    background-color: black;
    transition: background-color 150ms linear;
  }

  .move-buttons-overlay {
    position: absolute;
    top: calc(50% - 21px);
    width: 117px;
    left: -20px;
    height: 42px;
    z-index: 998;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 2px 3px rgba(44, 61, 70, 0.15);
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .slide-fade-enter-active {
    transition: opacity 0.1s ease-in;
  }
  .slide-fade-leave-active {
    transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    opacity: 0;
  }

  .movement-drag-handle {
    position: absolute;
    cursor: move;
    left: -13px;
    width: 30px;
    height: 30px;
    border-radius: 999px;
    background-color: #3c4048;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
    font-size: 12px;
    color: #ffffff;
    top: calc(50% - 15px);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .movement-drag-handle:hover {
    background-color: black;
    transition: background-color 150ms linear;
  } */
</style>
